import { faCaretDown, faCaretRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Collapse, List } from "antd";
import React from "react";
import GlobalStoreContext from "../../context/GlobalStoreContext";
import { Area } from "../../models/Area";
import WaypointGuidance from "../DamnPage/WaypointGuidance/WaypointGuidance";
import WaypointStepView from "./WaypointStep";

const { Panel } = Collapse;

interface Props {
    waypoint: Area;
    dropoff?: Area;
    title: React.ReactNode;
}

const WaypointDirections: React.FC<Props> = (props) => {
    const context = React.useContext(GlobalStoreContext);
    const [expanded, setExpanded] = React.useState<boolean>(false);

    const waypointSteps = props.waypoint.waypointDirection?.waypointSteps?.sort((a, b) => a.stepNumber - b.stepNumber);

    const startWaypointGuidance = (e) => {
        e.stopPropagation();
        // If we already have a user location, toggle the geolocation control first so that
        // any existing tracking session is reset before starting waypoint guidance.
        if (context.userLocation) {
            context.geoControlRef.current?.trigger();
        }
        context.setWaypointGuidance(true);
    };

    return (
        <>
            <React.Fragment>
                {waypointSteps && waypointSteps.length > 0 && (
                    <Collapse
                        accordion
                        expandIconPlacement="end"
                        ghost
                        onChange={(e) => setExpanded(e.length > 0 ? true : false)}
                    >
                        <Panel
                            showArrow={false}
                            className=" px-4 py-3 bg-linear-to-r bg-gray-50 dark:bg-neutral-800  rounded-lg! "
                            header={
                                <div className="flex flex-row w-full">
                                    <div className="flex flex-col w-full gap-2">
                                        <div className="flex items-center w-full justify-between">
                                            {props.title}
                                            <FontAwesomeIcon
                                                icon={expanded ? faCaretDown : faCaretRight}
                                                className="text-slate-500"
                                            />
                                        </div>
                                        {expanded ? (
                                            <button
                                                onClick={startWaypointGuidance}
                                                className="cursor-pointer w-full text-center font-semibold border border-plot-slate p-2 rounded-lg hover:scale-110 hover:bg-plot-slate hover:text-plot-white transition-all duration-300"
                                            >
                                                Start Turn-By-Turn Guidance
                                            </button>
                                        ) : (
                                            <p className="text-xs text-gray-600 font-medium w-full text-center italic">
                                                Expand for Turn-By-Turn Guidance
                                            </p>
                                        )}
                                    </div>
                                </div>
                            }
                            key="1"
                        >
                            <List
                                dataSource={waypointSteps.filter((step) => !step._destroy && !step.hidden)}
                                renderItem={(step, index) => (
                                    <List.Item key={index}>
                                        <WaypointStepView waypointStep={step} index={index} />
                                    </List.Item>
                                )}
                            />
                        </Panel>
                    </Collapse>
                )}
            </React.Fragment>

            <WaypointGuidance
                active={context.waypointGuidance}
                cancel={() => {
                    context.geoControlRef.current?.trigger();
                    context.setWaypointGuidance(false);
                }}
                waypoint={props.waypoint}
                dropoff={props.dropoff}
            />
        </>
    );
};

export default WaypointDirections;
